<!-- -->
<template>
  <div class="dialog" v-show="show">
    <div class="mask" @click="closeDialog"></div>
    <div class="content">
      <img
        src="../assets/close.png"
        alt=""
        class="close"
        @click="closeDialog"
      />
      <img
        src="http://gxbg.pangodso.com/file/static/dialog_pz.png"
        alt=""
        class="pz"
        v-show="!success"
      />
      <div class="form">
        <el-form inline label-position="top" v-show="!success">
          <el-form-item label="姓名">
            <el-input
              v-model="addParams.userName"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input
              v-model="addParams.phone"
              type="number"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="公司名称">
            <el-input
              v-model="addParams.companyName"
              placeholder="请输入公司名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="所属区域">
            <el-input
              v-model="addParams.address"
              placeholder="请输入所属区域"
            ></el-input>
          </el-form-item>
          <el-form-item label="咨询内容" style="width: 100%">
            <el-input
              v-model="addParams.content"
              type="textarea"
              rows="4"
              placeholder="请输入咨询内容"
            ></el-input>
          </el-form-item>
        </el-form>
        <button class="submit" @click="submitForm" v-show="!success">
          立即提交
        </button>
        <img
          src="http://gxbg.pangodso.com/file/static/dialog_success.png"
          alt=""
          class="success"
          v-show="success"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      addParams: {
        address: "",
        companyName: "",
        userName: "",
        content: "",
        phone: "",
      },
      addRules: {
        userName: { message: "请输入姓名" },
        content: { message: "请输入咨询内容" },
        phone: { message: "请输入联系电话" },
      },
      success: false,
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show(val) {
      if (!val) {
        this.success = false;
      }
    },
  },
  methods: {
    submitForm() {
      for (const key in this.addRules) {
        if (!this.addParams[key]) {
          this.$notify.error({ title: this.addRules[key].message });
          return;
        }
      }
      // 校验通过
      this.$api.addFeedBack(this.addParams).then((res) => {
        if (res.code == 0) {
          this.success = true;
          this.$notify.success({ title: "提交成功!" });
          Object.assign(this.$data.addParams, this.$options.data().addParams);
        }
      });
    },
    closeDialog() {
      this.$emit("update:show", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
}
.mask {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba($color: #000, $alpha: 0.5);
}
.content {
  width: 640px;
  height: 480px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
}
.close {
  width: 30px;
  position: absolute;
  right: 20px;
  top: 35px;
  cursor: pointer;
}
.pz {
  position: absolute;
  left: 10px;
  top: -160px;
  z-index: -1;
}
.form {
  width: 100%;
  height: 100%;
  background-image: url("http://gxbg.pangodso.com/file/static/dialog_bg.png");
  background-size: 100% 100%;
}
.el-form {
  width: 100%;
  padding: 0 60px;
  box-sizing: border-box;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  .el-form-item {
    width: 48%;
  }
  :deep(.el-form-item__label) {
    color: #fff;
    line-height: 1;
  }
}
.submit {
  width: 60%;
  height: 70px;
  box-shadow: inset 1px 6px 10px rgba($color: #fff, $alpha: 0.77);
  font-weight: bold;
  background-image: linear-gradient(to bottom, #7ea8eb, #0253d8);
  border-radius: 50px;
  font-size: 30px;
  line-height: 70px;
  text-align: center;
  color: #fff;
  position: absolute;
  left: 50%;
  bottom: -35px;
  transform: translateX(-50%);
}
.success {
  width: 400px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
